import { render, staticRenderFns } from "./MarketingHowWorks.vue?vue&type=template&id=f8577fb6&"
import script from "./MarketingHowWorks.vue?vue&type=script&lang=ts&"
export * from "./MarketingHowWorks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports